import React from 'react';

const CapacityPlanningFilterBar = ({ filters, onRefresh }) => {
  const {
    scopeType,
    setScopeType,
    priority,
    setPriority,
    area,
    setArea,
    expansionType,
    setExpansionType,
    urgencyThreshold,
    setUrgencyThreshold,
  } = filters;

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/80 p-3">
      <div className="grid gap-2 md:grid-cols-3 xl:grid-cols-6">
        <select value={scopeType} onChange={(e) => setScopeType(e.target.value)} className="rounded-md border border-slate-700 bg-slate-950 px-2 py-2 text-sm text-slate-200">
          <option value="ALL">Semua Scope</option>
          <option value="AREA">Area</option>
          <option value="ODP">ODP</option>
          <option value="PON">PON</option>
          <option value="OLT">OLT</option>
        </select>
        <select value={priority} onChange={(e) => setPriority(e.target.value)} className="rounded-md border border-slate-700 bg-slate-950 px-2 py-2 text-sm text-slate-200">
          <option value="ALL">Semua Prioritas</option>
          <option value="CRITICAL">CRITICAL</option>
          <option value="HIGH">HIGH</option>
          <option value="MEDIUM">MEDIUM</option>
          <option value="LOW">LOW</option>
        </select>
        <input value={area} onChange={(e) => setArea(e.target.value)} placeholder="Filter area" className="rounded-md border border-slate-700 bg-slate-950 px-2 py-2 text-sm text-slate-200 placeholder:text-slate-500" />
        <select value={expansionType} onChange={(e) => setExpansionType(e.target.value)} className="rounded-md border border-slate-700 bg-slate-950 px-2 py-2 text-sm text-slate-200">
          <option value="ALL">Semua Rekomendasi</option>
          <option value="ADD_ODP_CAPACITY">Tambah Kapasitas ODP</option>
          <option value="REBALANCE_PON">Rebalance PON</option>
          <option value="EXPAND_DISTRIBUTION">Ekspansi Distribusi</option>
          <option value="PRIORITIZE_INSTALLATION">Prioritaskan Instalasi</option>
          <option value="REVIEW_CAPACITY_PLAN">Review Capacity Plan</option>
          <option value="INVESTIGATE_BOTTLENECK">Investigasi Bottleneck</option>
        </select>
        <input type="number" min={0} max={100} value={urgencyThreshold} onChange={(e) => setUrgencyThreshold(Number(e.target.value || 0))} placeholder="Urgensi min" className="rounded-md border border-slate-700 bg-slate-950 px-2 py-2 text-sm text-slate-200" />
        <button type="button" onClick={onRefresh} className="rounded-md border border-slate-700 bg-slate-800 px-3 py-2 text-sm font-medium text-slate-200 hover:bg-slate-700">
          Refresh
        </button>
      </div>
    </div>
  );
};

export default CapacityPlanningFilterBar;
